import { createRoot } from 'react-dom/client'
import './index.css'
import { BrowserRouter } from "react-router";
import ScaenaRouter from './utils/Routes.tsx';
import { HelmetProvider } from 'react-helmet-async';
import MobileStoreFrame from './app/MobileStoreFrame.tsx';
import StorefrontFrame from './app/StorefrontFrame.tsx';
createRoot(document.getElementById('root')!).render(
  <HelmetProvider>
  <BrowserRouter>
   <MobileStoreFrame>
    <StorefrontFrame>
      <ScaenaRouter></ScaenaRouter>
    </StorefrontFrame>
   </MobileStoreFrame>
  </BrowserRouter>    
  </HelmetProvider>
,
)
